//@flow
/**
 * Created by Abhishek Gupta on 11/05/21.
 */
import type { LatLng } from 'common/models/internal/LatLng';

class InnerPolygonMaker {
    static squaredPolar(point: Array<number>, centre: Array<number>) {
        return [
            Math.atan2(point[1] - centre[1], point[0] - centre[0]),
            (point[0] - centre[0]) ** 2 + (point[1] - centre[1]) ** 2 // Square of distance
        ];
    }

    // Main algorithm:
    static polySort(points: ?Array<LatLng>) {
        // Get "centre of mass"
        const updatedPoints = [...points];
        const centre = [
            updatedPoints.reduce((sum, p) => sum + p[0], 0) / points.length,
            updatedPoints.reduce((sum, p) => sum + p[1], 0) / points.length
        ];

        // Sort by polar angle and distance, centered at this centre of mass.
        updatedPoints.forEach(point => {
            point.push(...InnerPolygonMaker.squaredPolar(point, centre));
        });
        updatedPoints.sort((a, b) => a[2] - b[2] || a[3] - b[3]);
        // Throw away the temporary polar coordinates
        updatedPoints.forEach(point => {
            point.length = point.length - 2;
        });
        return updatedPoints;
    }
}

export default InnerPolygonMaker;
